module.exports = __webpack_public_path__ + "static/media/logo.d72116be.jpg";